import type { GameState } from "./types";

export type RunReward = {
  gold: number;
  xp: number;
  masteryPoints: number;
};

export function calculateRunReward(state: GameState, level: number, won: boolean): RunReward {
  const baseReward = won ? 50 : 0;
  const scoreReward = Math.floor(state.score / 100);
  const objectiveReward = won ? 100 : 0;
  const comboBonus = Math.floor(state.combo.best * 5);
  const difficultyBonus = won ? level * 2 : 0;
  return {
    gold: state.rewards.gold + baseReward + scoreReward + objectiveReward + comboBonus + difficultyBonus,
    xp: won ? 40 + level * 3 + state.treasuresCollected * 5 : 8 + state.treasuresCollected * 2,
    masteryPoints: won && state.trapsTriggered === 0 ? 1 : 0,
  };
}
